import {
  asyncActionFinish,
  asyncActionError,
} from '../../../App/common/reduxs/async/asyncActions';
import { ASYNC_ACTION_START } from '../../../App/common/reduxs/async/asyncConstant';
import {
  SITE_ADDRESS,
  SITE_ADDRESS_PEMBELAJARAN,
} from '../../../App/common/data/siteConfig';
// import {
//   materisGet,
//   tugassGet,
//   latihansGet,
//   tessGet,
//   studentActivityGet,
// } from '../../_features/pembelajaran/redux/reduxAction';
import { checkRes, checkErr } from '../../../App/common/helpers/checkRes';
import { unreadPesanGet } from './reduxAction';
import { activitiesGet } from '../../_features/aktivitas-belajar/redux/reduxAction';
import { jadwalGet } from '../../_features/jadwal/redux/reduxAction';
import { kalenderGet } from '../../_features/kalender/redux/reduxAction';
import { notesGet } from '../../_features/note/redux/reduxAction';

export const getDashboard = (auth, history) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'getDashboard' });
    const vusn = auth.vusn;
    const userId = auth.userId;
    const sessionId = auth.sessionId ? auth.sessionId : null;
    const deviceId = auth.deviceId ? auth.deviceId : null;
    console.log(sessionId, deviceId);
    const formData = new FormData();
    formData.append('vusn', vusn);
    formData.append('userId', userId);
    formData.append('sessionId', sessionId);
    formData.append('deviceId', deviceId);
    try {
      let fetchData = await fetch(SITE_ADDRESS + 'dashboard/', {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: 'Bearer ' + auth.token,
        },
      });
      const res = await fetchData.json();
      const resultCheck = checkRes(res, fetchData, dispatch, 200, history);
      if (resultCheck) {
        throw resultCheck;
      }
      const dashboard = res.dashboard;
      console.log(dashboard);
      dispatch(asyncActionFinish());
    } catch (error) {
      checkErr(error);
      dispatch(asyncActionError());
    }
  };
};

export const getPembelajaran = (auth, history, tingkat, kelas) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'getPembelajaran' });
    const vusn = auth.vusn;
    const userId = auth.userId;
    const sessionId = auth.sessionId ? auth.sessionId : null;
    const deviceId = auth.deviceId ? auth.deviceId : null;
    const formData = new FormData();
    formData.append('vusn', vusn);
    formData.append('userId', userId);
    formData.append('sessionId', sessionId);
    formData.append('deviceId', deviceId);
    formData.append('jenjang', auth.active_jenjang);
    formData.append('tingkat', auth.active_tingkat);
    formData.append('kelas', auth.active_kelas);
    formData.append('year', auth.active_year);
    formData.append('sem', auth.active_sem);
    try {
      let fetchData = await fetch(
        SITE_ADDRESS_PEMBELAJARAN + 'pembelajaran/all-contents',
        {
          method: 'POST',
          body: formData,
          headers: {
            Authorization: 'Bearer ' + auth.token,
          },
        }
      );
      const response = await fetchData.json();
      const resultCheck = checkRes(response, fetchData, dispatch, 200, history);
      if (resultCheck) {
        throw resultCheck;
      }

      const jadwal = response.jadwal;
      const kelass = response.kelass;
      const pelajarans = response.pelajarans;
      const gurus = response.gurus;
      const activity = response.activity;
      const calendar = response.calendar;

      dispatch(activitiesGet(activity));
      dispatch(jadwalGet({ jadwal, kelass, pelajarans, gurus }));
      dispatch(kalenderGet(calendar));
      dispatch(asyncActionFinish());
      return 'finish';
    } catch (error) {
      checkErr(error);
      dispatch(asyncActionError());
    }
  };
};

export const getActivities = (auth, history, tingkat, kelas) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'getActivities' });
    const vusn = auth.vusn;
    const userId = auth.userId;
    const sessionId = auth.sessionId ? auth.sessionId : null;
    const deviceId = auth.deviceId ? auth.deviceId : null;
    const formData = new FormData();
    formData.append('vusn', vusn);
    formData.append('userId', userId);
    formData.append('sessionId', sessionId);
    formData.append('deviceId', deviceId);
    formData.append('jenjang', auth.active_jenjang);
    formData.append('tingkat', auth.active_tingkat);
    formData.append('kelas', auth.active_kelas);
    formData.append('year', auth.active_year);
    formData.append('sem', auth.active_sem);
    try {
      let fetchData = await fetch(
        SITE_ADDRESS_PEMBELAJARAN + 'pembelajaran/all-activities',
        {
          method: 'POST',
          body: formData,
          headers: {
            Authorization: 'Bearer ' + auth.token,
          },
        }
      );
      const response = await fetchData.json();
      const resultCheck = checkRes(response, fetchData, dispatch, 200, history);
      if (resultCheck) {
        throw resultCheck;
      }

      const jadwal = response.jadwal;
      const kelass = response.kelass;
      const pelajarans = response.pelajarans;
      const gurus = response.gurus;
      const activity = response.activity;
      const note = response.note;
      const calendar = response.calendar;

      dispatch(activitiesGet({ items: activity, total: activity?.length }));
      dispatch(notesGet({ items: note, total: note?.length }));
      dispatch(jadwalGet({ jadwal, kelass, pelajarans, gurus }));
      dispatch(kalenderGet(calendar));
      dispatch(asyncActionFinish());
      return 'finish';
    } catch (error) {
      checkErr(error);
      dispatch(asyncActionError());
    }
  };
};

export const getUnreadPesan = (auth, history) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'getUnreadPesan' });
    if (auth && !auth.isAuth) {
      dispatch(asyncActionFinish());
      return;
    }
    const vusn = auth.vusn;
    const userId = auth.userId;
    const sessionId = auth.sessionId ? auth.sessionId : null;
    const deviceId = auth.deviceId ? auth.deviceId : null;
    const formData = new FormData();
    formData.append('vusn', vusn);
    formData.append('userId', userId);
    formData.append('sessionId', sessionId);
    formData.append('deviceId', deviceId);
    try {
      let fetchData = await fetch(
        SITE_ADDRESS_PEMBELAJARAN + 'pesan-pribadi/unread/' + userId,
        {
          method: 'POST',
          body: formData,
          headers: {
            Authorization: 'Bearer ' + auth.token,
          },
        }
      );
      const response = await fetchData.json();
      const resultCheck = checkRes(response, fetchData, dispatch, 200, history);
      if (resultCheck) {
        throw resultCheck;
      }
      const unreadPesan = response.unreadPesan;
      dispatch(unreadPesanGet(unreadPesan));
      dispatch(asyncActionFinish());
    } catch (error) {
      checkErr(error);
      dispatch(asyncActionError());
    }
  };
};
